import { ciAppartments } from '~/icons/source/light/appartments'
import { ciTownhomes } from '~/icons/source/light/townhomes'
import { ciAllTypes } from '~/icons/source/light/all-types'
import { ciMaps } from '~/icons/source/regular/maps'
import { ciPenthouse } from '~/icons/source/light/penthouse'
import { ciForSale } from '~/icons/source/regular/for-sale'
import { ciForRent } from '~/icons/source/regular/for-rent'
import { ciShopBuilding } from '~/icons/source/light/shop-building'
import { ciHome } from '~/icons/source/regular/home'

export const plotCategoryKeyFeaturesIcons = Object.freeze({
  apartment: {
    icon: ciAppartments
  },
  detached_home: {
    icon: ciTownhomes
  },
  apartment_complex: {
    icon: ciAllTypes
  },
  parcel: {
    icon: ciMaps
  },
  land: {
    icon: ciMaps
  },
  // level 2
  studio: {
    icon: ciAppartments
  },
  home: {
    icon: ciAllTypes
  },
  hotel: {
    icon: ciPenthouse
  },
  // level 3
  sale: {
    icon: ciForSale
  },
  rent: {
    icon: ciForRent
  },
  // level 4
  real_estate: {
    icon: ciShopBuilding
  },
  // level 5
  classifieds: {
    icon: ciHome
  }
})
